import React, { useContext, useEffect, useState, useMemo } from 'react';

import { MobileContext } from 'context';
import { FormattedPrice } from 'utils/Price';
import { useGameDetails } from 'utils/Hooks';
import ThumbsUp from 'assets/art/DOGE_BETS_CIRCLE_UP.webp';
import ThumbsDown from 'assets/art/DOGE_BETS_CIRCLE_DOWN.webp';
import ThumbsNeutral from 'assets/art/DOGE_BETS_CIRCLE_TIE.webp';
import './index.scss';
import { useCurrentPrice } from 'utils/Hooks/price';


const priceAction = Object.freeze({
  up: 0,
  down: 1,
  tie: 2,
});

function CurrentPrice(props) {
  const isMobile = useContext(MobileContext);

  const gameDetails = useGameDetails();
  const currentPrice = useCurrentPrice();

  const [lockPrice, SetLockPrice] = useState(0);
  const [colorOfPA, SetColorOfPA] = useState('var(--color-theme-white)');
  const [imageForPA, SetImageForPA] = useState(null);
  // const [iconForPA, setIconForPA] = useState(null);

  const contentsM = useMemo(Contents
    , [gameDetails, imageForPA, colorOfPA, currentPrice, lockPrice]); /* eslint-disable-line react-hooks/exhaustive-deps */


  useEffect(() => {
    let fallbackTimeout = null;
    if (!Number(currentPrice) || !Number(lockPrice)) {
      fallbackTimeout = setTimeout(props.OnLoad, 5000);
    } else {
      props.OnLoad();
    }
    return () => {
      clearTimeout(fallbackTimeout);
    };
  }, [currentPrice, lockPrice, props.OnLoad]); /* eslint-disable-line react-hooks/exhaustive-deps */

  useEffect(() => {
    UpdateLockPrice();
  }, [props.lockPrice, gameDetails]); /* eslint-disable-line react-hooks/exhaustive-deps */

  useEffect(() => {
    UpdateColorAccordingToPA();
  }, [currentPrice, lockPrice, gameDetails]); // eslint-disable-line react-hooks/exhaustive-deps


  function UpdateLockPrice() {
    if (!props.lockPrice) {
      SetLockPrice(0);
    } else {
      const newLockPrice = (Number(props.lockPrice) / 10 ** 8).toFixed(gameDetails.priceDecimals);
      SetLockPrice(newLockPrice);
    }
  }

  function UpdateColorAccordingToPA() {
    let newColor, newImage, ActivateGlow;

    switch (GetPriceAction()) {
      case priceAction.up:
        newColor = 'var(--color-bull-green)';
        newImage = ThumbsUp;
        ActivateGlow = props.OnBullAction;
        break;
      case priceAction.down:
        newColor = 'var(--color-bear-red)';
        newImage = ThumbsDown;
        ActivateGlow = props.OnBearAction;
        break;
      default:
        newColor = 'var(--color-theme-white)';
        newImage = ThumbsNeutral;
        ActivateGlow = props.OnNeutralAction;
        break;
    }
    if (newColor !== colorOfPA || newImage !== imageForPA) {
      SetColorOfPA(newColor);
      SetImageForPA(newImage);
      ActivateGlow();
    }
  }

  function GetPriceAction() {
    const difference = Number(currentPrice) - Number(lockPrice);
    if (difference > 0)
      return priceAction.up;
    else if (difference < 0)
      return priceAction.down;
    else
      return priceAction.tie;
  }

  function PriceDifference() {
    const difference = Number(currentPrice) - Number(lockPrice);
    let percentage;
    if (Number(lockPrice) === 0)
      /* eslint-disable-line eqeqeq */
      percentage = "N/A";
    else
      percentage = (
        ((Number(currentPrice) - Number(lockPrice)) / Number(lockPrice)) *
        100
      ).toFixed(2);

    let formattedDifference;
    if (difference > 0)
      formattedDifference =
        "+" + difference.toFixed(gameDetails.priceDecimals);
    else if (difference < 0)
      formattedDifference = difference.toFixed(gameDetails.priceDecimals);
    // negative numbers are aready prefixed with '-'
    else formattedDifference = " 0.00";
    return (
      <div id="Difference">
        <p style={{ color: colorOfPA }}>
          ${formattedDifference} ({percentage}%)
        </p>
      </div>
    );
  }

  function PriceAction() {
    let price;
    //let message;
    const currentPA = GetPriceAction();

    if (currentPA === undefined || currentPA === null) price = null;
    else price = currentPrice;

    return (
      <div id='CurrentPrice'>
        <p style={{ color: colorOfPA }}>
          <FormattedPrice price={price} />
          <span>USDT</span>
        </p>
      </div>
      // <div id="CurrentPrice">
      //   <p style={{ color: colorOfPA }}>
      //     <FormattedPrice price={price} />
      //   </p>
      // </div>
    );
  }

  function Contents() {
    if (!currentPrice || !lockPrice)
      return (
        <React.Fragment>
          <div className='ImageContainer'>
            <img src={imageForPA} alt='thumbs' />
          </div>
          <div className='PriceContainer'>
            <p id='Loading'>Loading...</p>
          </div>
        </React.Fragment>
      );
    else
      return (
        <React.Fragment>
          <div className='ImageContainer'>
            <img src={imageForPA} alt='thumbs' />
          </div>
          <div className='PriceContainer'>
            <PriceAction />
            <PriceDifference />
          </div>
        </React.Fragment>
      );
  }

  return (
    <div className='ThemeBox OvalContainer'>
      <div className={'Oval' + (isMobile ? ' Mobile' : '')} style={{ border: '4px solid ' + colorOfPA }}>
        {contentsM}
      </div>
    </div>
  );
}

export default CurrentPrice;
